import _classCallCheck from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/usr/src/app/www/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { usePress, isFocusVisible } from "@react-aria/interactions";
import { useFocusable, focusSafely, getFocusableTreeWalker } from "@react-aria/focus";
import { useSelectableCollection, useSelectableItem } from "@react-aria/selection";
import { useCollator, useLocale } from "@react-aria/i18n";
import { Rect } from "@react-stately/virtualizer";
import { useMemo } from "react";
import { filterDOMProps, mergeProps, useId } from "@react-aria/utils";
import _babelRuntimeHelpersEsmExtends from "@babel/runtime/helpers/esm/extends";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $fd8271485d8e52f870169aca977a9c1$export$gridIds = new WeakMap();

function $fd8271485d8e52f870169aca977a9c1$var$normalizeKey(key) {
  if (typeof key === 'string') {
    return key.replace(/\s*/g, '');
  }

  return '' + key;
}

function $fd8271485d8e52f870169aca977a9c1$export$getColumnHeaderId(state, columnKey) {
  var gridId = $fd8271485d8e52f870169aca977a9c1$export$gridIds.get(state);

  if (!gridId) {
    throw new Error('Unknown grid');
  }

  return gridId + "-" + $fd8271485d8e52f870169aca977a9c1$var$normalizeKey(columnKey);
}

function $fd8271485d8e52f870169aca977a9c1$export$getCellId(state, rowKey, columnKey) {
  var gridId = $fd8271485d8e52f870169aca977a9c1$export$gridIds.get(state);

  if (!gridId) {
    throw new Error('Unknown grid');
  }

  return gridId + "-" + $fd8271485d8e52f870169aca977a9c1$var$normalizeKey(rowKey) + "-" + $fd8271485d8e52f870169aca977a9c1$var$normalizeKey(columnKey);
}

function $fd8271485d8e52f870169aca977a9c1$export$getRowLabelledBy(state, rowKey) {
  // A row is labelled by it's row headers.
  return _toConsumableArray(state.collection.rowHeaderColumnKeys).map(function (columnKey) {
    return $fd8271485d8e52f870169aca977a9c1$export$getCellId(state, rowKey, columnKey);
  }).join(' ');
}

var $dabf6db3fde4ddfaf13a80216b120e5f$export$TableKeyboardDelegate = /*#__PURE__*/function () {
  function $dabf6db3fde4ddfaf13a80216b120e5f$export$TableKeyboardDelegate(options) {
    _classCallCheck(this, $dabf6db3fde4ddfaf13a80216b120e5f$export$TableKeyboardDelegate);

    this.collection = void 0;
    this.disabledKeys = void 0;
    this.ref = void 0;
    this.direction = void 0;
    this.collator = void 0;
    this.layout = void 0;
    this.collection = options.collection;
    this.disabledKeys = options.disabledKeys;
    this.ref = options.ref;
    this.direction = options.direction;
    this.collator = options.collator;
    this.layout = options.layout;
  }

  _createClass($dabf6db3fde4ddfaf13a80216b120e5f$export$TableKeyboardDelegate, [{
    key: "isCell",
    value: function isCell(node) {
      return node.type === 'cell' || node.type === 'rowheader';
    }
  }, {
    key: "findPreviousKey",
    value: function findPreviousKey(pred, fromKey) {
      var key = fromKey != null ? this.collection.getKeyBefore(fromKey) : this.collection.getLastKey();

      while (key != null) {
        var item = this.collection.getItem(key);

        if (pred(item)) {
          return key;
        }

        key = this.collection.getKeyBefore(key);
      }
    }
  }, {
    key: "findNextKey",
    value: function findNextKey(pred, fromKey) {
      var key = fromKey != null ? this.collection.getKeyAfter(fromKey) : this.collection.getFirstKey();

      while (key != null) {
        var item = this.collection.getItem(key);

        if (pred(item)) {
          return key;
        }

        key = this.collection.getKeyAfter(key);
      }
    }
  }, {
    key: "getKeyBelow",
    value: function getKeyBelow(key) {
      var startItem = this.collection.getItem(key);

      if (!startItem) {
        return;
      } // If focus was on a column, then focus the first child column if any,
      // or find the corresponding cell in the first row.


      if (startItem.type === 'column') {
        var child = _toConsumableArray(startItem.childNodes)[0];

        if (child) {
          return child.key;
        }

        var firstItem = this.collection.getItem(this.getFirstKey());
        return _toConsumableArray(firstItem.childNodes)[startItem.index].key;
      } // If focus was on a cell, start searching from the parent row


      if (this.isCell(startItem)) {
        key = startItem.parentKey;
      } // Find the next item


      key = this.findNextKey(function (item) {
        return item.type === 'item';
      }, key);

      if (key != null) {
        // If focus was on a cell, focus the cell with the same index in the next row.
        if (this.isCell(startItem)) {
          var item = this.collection.getItem(key);
          return _toConsumableArray(item.childNodes)[startItem.index].key;
        } // Otherwise, focus the next row


        return key;
      }
    }
  }, {
    key: "getKeyAbove",
    value: function getKeyAbove(key) {
      var startItem = this.collection.getItem(key);

      if (!startItem) {
        return;
      } // If focus was on a column, focus the parent column if any


      if (startItem.type === 'column') {
        var parent = this.collection.getItem(startItem.parentKey);

        if (parent && parent.type === 'column') {
          return parent.key;
        }

        return;
      } // If focus is on a cell, start searching from the parent row


      if (this.isCell(startItem)) {
        key = startItem.parentKey;
      } // Find the previous item


      key = this.findPreviousKey(function (item) {
        return item.type === 'item';
      }, key);

      if (key != null) {
        // If focus was on a cell, focus the cell with the same index in the previous row.
        if (this.isCell(startItem)) {
          var item = this.collection.getItem(key);
          return _toConsumableArray(item.childNodes)[startItem.index].key;
        } // Otherwise, focus the previous row


        return key;
      } // If no item was found, and focus was on a cell, then focus the
      // corresponding column header.


      if (this.isCell(startItem)) {
        return this.collection.columns[startItem.index].key;
      } // If focus was on a row, then focus the first column header.


      return this.collection.columns[0].key;
    }
  }, {
    key: "findNextColumnKey",
    value: function findNextColumnKey(column) {
      // Search following columns
      var key = this.findNextKey(function (item) {
        return item.type === 'column';
      }, column.key);

      if (key != null) {
        return key;
      } // Wrap around to the first column


      var row = this.collection.headerRows[column.level];

      var _iterator = _createForOfIteratorHelper(row.childNodes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.type === 'column') {
            return item.key;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "findPreviousColumnKey",
    value: function findPreviousColumnKey(column) {
      // Search previous columns
      var key = this.findPreviousKey(function (item) {
        return item.type === 'column';
      }, column.key);

      if (key != null) {
        return key;
      } // Wrap around to the last column


      var row = this.collection.headerRows[column.level];

      var childNodes = _toConsumableArray(row.childNodes);

      for (var i = childNodes.length - 1; i >= 0; i--) {
        var item = childNodes[i];

        if (item.type === 'column') {
          return item.key;
        }
      }
    }
  }, {
    key: "getKeyRightOf",
    value: function getKeyRightOf(key) {
      var item = this.collection.getItem(key);

      if (!item) {
        return;
      } // If focus was on a column, then focus the next column


      if (item.type === 'column') {
        return this.direction === 'rtl' ? this.findPreviousColumnKey(item) : this.findNextColumnKey(item);
      } // If focus is on a row, focus the first child cell.


      if (item.type === 'item') {
        var children = _toConsumableArray(item.childNodes);

        return this.direction === 'rtl' ? children[children.length - 1].key : children[0].key;
      } // If focus is on a cell, focus the next cell if any,
      // otherwise focus the parent row.


      if (this.isCell(item)) {
        var parent = this.collection.getItem(item.parentKey);

        var _children = _toConsumableArray(parent.childNodes);

        var next = this.direction === 'rtl' ? _children[item.index - 1] : _children[item.index + 1];

        if (next) {
          return next.key;
        }

        return item.parentKey;
      }
    }
  }, {
    key: "getKeyLeftOf",
    value: function getKeyLeftOf(key) {
      var item = this.collection.getItem(key);

      if (!item) {
        return;
      } // If focus was on a column, then focus the previous column


      if (item.type === 'column') {
        return this.direction === 'rtl' ? this.findNextColumnKey(item) : this.findPreviousColumnKey(item);
      } // If focus is on a row, focus the last child cell.


      if (item.type === 'item') {
        var children = _toConsumableArray(item.childNodes);

        return this.direction === 'rtl' ? children[0].key : children[children.length - 1].key;
      } // If focus is on a cell, focus the previous cell if any,
      // otherwise focus the parent row.


      if (this.isCell(item)) {
        var parent = this.collection.getItem(item.parentKey);

        var _children2 = _toConsumableArray(parent.childNodes);

        var prev = this.direction === 'rtl' ? _children2[item.index + 1] : _children2[item.index - 1];

        if (prev) {
          return prev.key;
        }

        return parent.key;
      }
    }
  }, {
    key: "getFirstKey",
    value: function getFirstKey(key, global) {
      var item;

      if (key != null) {
        item = this.collection.getItem(key);

        if (!item) {
          return;
        } // If global flag is not set, and a cell is currently focused,
        // move focus to the first cell in the parent row.


        if (this.isCell(item) && !global) {
          var parent = this.collection.getItem(item.parentKey);
          return _toConsumableArray(parent.childNodes)[0].key;
        }
      } // Find the first row


      key = this.findNextKey(function (item) {
        return item.type === 'item';
      }); // If global flag is set, focus the first cell in the first row.

      if (key != null && item && this.isCell(item) && global) {
        var _item = this.collection.getItem(key);

        key = _toConsumableArray(_item.childNodes)[0].key;
      } // Otherwise, focus the row itself.


      return key;
    }
  }, {
    key: "getLastKey",
    value: function getLastKey(key, global) {
      var item;

      if (key != null) {
        item = this.collection.getItem(key);

        if (!item) {
          return;
        } // If global flag is not set, and a cell is currently focused,
        // move focus to the last cell in the parent row.


        if (this.isCell(item) && !global) {
          var parent = this.collection.getItem(item.parentKey);

          var children = _toConsumableArray(parent.childNodes);

          return children[children.length - 1].key;
        }
      } // Find the last row


      key = this.findPreviousKey(function (item) {
        return item.type === 'item';
      }); // If global flag is set, focus the last cell in the last row.

      if (key != null && item && this.isCell(item) && global) {
        var _item2 = this.collection.getItem(key);

        var _children3 = _toConsumableArray(_item2.childNodes);

        key = _children3[_children3.length - 1].key;
      } // Otherwise, focus the row itself.


      return key;
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.ref.current.querySelector("[data-key=\"" + key + "\"]");
    }
  }, {
    key: "getItemRect",
    value: function getItemRect(key) {
      if (this.layout) {
        var _this$layout$getLayou;

        return (_this$layout$getLayou = this.layout.getLayoutInfo(key)) == null ? void 0 : _this$layout$getLayou.rect;
      }

      var item = this.getItem(key);

      if (item) {
        return new Rect(item.offsetLeft, item.offsetTop, item.offsetWidth, item.offsetHeight);
      }
    }
  }, {
    key: "getPageHeight",
    value: function getPageHeight() {
      var _this$ref, _this$ref$current;

      if (this.layout) {
        var _this$layout$virtuali;

        return (_this$layout$virtuali = this.layout.virtualizer) == null ? void 0 : _this$layout$virtuali.visibleRect.height;
      }

      return (_this$ref = this.ref) == null ? void 0 : (_this$ref$current = _this$ref.current) == null ? void 0 : _this$ref$current.offsetHeight;
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight() {
      var _this$ref2, _this$ref2$current;

      if (this.layout) {
        return this.layout.getContentSize().height;
      }

      return (_this$ref2 = this.ref) == null ? void 0 : (_this$ref2$current = _this$ref2.current) == null ? void 0 : _this$ref2$current.scrollHeight;
    }
  }, {
    key: "getKeyPageAbove",
    value: function getKeyPageAbove(key) {
      var itemRect = this.getItemRect(key);

      if (!itemRect) {
        return null;
      }

      var pageY = Math.max(0, itemRect.maxY - this.getPageHeight());

      while (itemRect && itemRect.y > pageY) {
        key = this.getKeyAbove(key);
        itemRect = this.getItemRect(key);
      }

      return key;
    }
  }, {
    key: "getKeyPageBelow",
    value: function getKeyPageBelow(key) {
      var itemRect = this.getItemRect(key);

      if (!itemRect) {
        return null;
      }

      var pageHeight = this.getPageHeight();
      var pageY = Math.min(this.getContentHeight(), itemRect.y + pageHeight);

      while (itemRect && itemRect.maxY < pageY) {
        var nextKey = this.getKeyBelow(key);
        itemRect = this.getItemRect(nextKey); // Guard against case where maxY of the last key is barely less than pageY due to rounding
        // and thus it attempts to set key to null

        if (nextKey != null) {
          key = nextKey;
        }
      }

      return key;
    }
  }, {
    key: "getKeyForSearch",
    value: function getKeyForSearch(search, fromKey) {
      if (!this.collator) {
        return null;
      }

      var collection = this.collection;
      var key = fromKey != null ? fromKey : this.getFirstKey(); // If the starting key is a cell, search from its parent row.

      var startItem = collection.getItem(key);

      if (startItem.type === 'cell') {
        key = startItem.parentKey;
      }

      var hasWrapped = false;

      while (key != null) {
        var item = collection.getItem(key); // Check each of the row header cells in this row for a match

        var _iterator2 = _createForOfIteratorHelper(item.childNodes),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var cell = _step2.value;
            var column = collection.columns[cell.index];

            if (collection.rowHeaderColumnKeys.has(column.key) && cell.textValue) {
              var substring = cell.textValue.slice(0, search.length);

              if (this.collator.compare(substring, search) === 0) {
                // If we started on a cell, end on the matching cell. Otherwise, end on the row.
                var fromItem = fromKey != null ? collection.getItem(fromKey) : startItem;
                return fromItem.type === 'cell' ? cell.key : item.key;
              }
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        key = this.getKeyBelow(key); // Wrap around when reaching the end of the collection

        if (key == null && !hasWrapped) {
          key = this.getFirstKey();
          hasWrapped = true;
        }
      }

      return null;
    }
  }]);

  return $dabf6db3fde4ddfaf13a80216b120e5f$export$TableKeyboardDelegate;
}();

export function useTable(props, state) {
  var ref = props.ref,
      isVirtualized = props.isVirtualized,
      keyboardDelegate = props.keyboardDelegate,
      layout = props.layout;

  if (!props['aria-label'] && !props['aria-labelledby']) {
    console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
  } // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
  // When virtualized, the layout object will be passed in as a prop and override this.


  var collator = useCollator({
    usage: 'search',
    sensitivity: 'base'
  });

  var _useLocale = useLocale(),
      direction = _useLocale.direction;

  var delegate = useMemo(function () {
    return keyboardDelegate || new $dabf6db3fde4ddfaf13a80216b120e5f$export$TableKeyboardDelegate({
      collection: state.collection,
      disabledKeys: state.disabledKeys,
      ref: ref,
      direction: direction,
      collator: collator,
      layout: layout
    });
  }, [keyboardDelegate, state.collection, state.disabledKeys, ref, direction, collator, layout]);

  var _useSelectableCollect = useSelectableCollection({
    ref: ref,
    selectionManager: state.selectionManager,
    keyboardDelegate: delegate
  }),
      collectionProps = _useSelectableCollect.collectionProps;

  var id = useId();
  $fd8271485d8e52f870169aca977a9c1$export$gridIds.set(state, id);
  var domProps = filterDOMProps(props, {
    labelable: true
  });
  var gridProps = mergeProps(domProps, _babelRuntimeHelpersEsmExtends({
    role: 'grid',
    id: id,
    'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
  }, collectionProps));

  if (isVirtualized) {
    gridProps['aria-rowcount'] = state.collection.size + state.collection.headerRows.length;
    gridProps['aria-colcount'] = state.collection.columns.length;
  }

  return {
    gridProps: gridProps
  };
}
export function useTableCell(props, state) {
  var node = props.node,
      ref = props.ref,
      isVirtualized = props.isVirtualized,
      isDisabled = props.isDisabled; // Handles focusing the cell. If there is a focusable child,
  // it is focused, otherwise the cell itself is focused.

  var focus = function focus() {
    var treeWalker = getFocusableTreeWalker(ref.current);
    var focusable = treeWalker.firstChild();

    if (focusable) {
      focusSafely(focusable);
    } else {
      focusSafely(ref.current);
    }
  };

  var _useSelectableItem = useSelectableItem({
    selectionManager: state.selectionManager,
    key: node.key,
    ref: ref,
    isVirtualized: isVirtualized,
    focus: focus
  }),
      itemProps = _useSelectableItem.itemProps; // TODO: move into useSelectableItem?


  var _usePress = usePress(_babelRuntimeHelpersEsmExtends({}, itemProps, {
    isDisabled: isDisabled
  })),
      pressProps = _usePress.pressProps; // Grid cells can have focusable elements inside them. In this case, focus should
  // be marshalled to that element rather than focusing the cell itself.


  var onFocus = function onFocus(e) {
    if (e.target !== ref.current) {
      // useSelectableItem only handles setting the focused key when
      // the focused element is the gridcell itself. We also want to
      // set the focused key when a child element receives focus.
      // If focus is currently visible (e.g. the user is navigating with the keyboard),
      // then skip this. We want to restore focus to the previously focused row/cell
      // in that case since the table should act like a single tab stop.
      if (!isFocusVisible()) {
        state.selectionManager.setFocusedKey(node.key);
      }

      return;
    } // If the cell itself is focused, wait a frame so that focus finishes propagatating
    // up to the tree, and move focus to a focusable child if possible.


    requestAnimationFrame(function () {
      if (document.activeElement === ref.current) {
        focus();
      }
    });
  };

  var gridCellProps = mergeProps(pressProps, {
    role: 'gridcell',
    onFocus: onFocus
  });

  if (isVirtualized) {
    gridCellProps['aria-colindex'] = node.index + 1; // aria-colindex is 1-based
  }

  return {
    gridCellProps: gridCellProps
  };
}
export function useTableColumnHeader(props, state) {
  var node = props.node,
      colspan = props.colspan,
      ref = props.ref,
      isDisabled = props.isDisabled;

  var _useTableCell = useTableCell(props, state),
      gridCellProps = _useTableCell.gridCellProps;

  var _usePress2 = usePress({
    isDisabled: !node.props.allowsSorting || isDisabled,
    onPress: function onPress() {
      state.sort(node.key);
    }
  }),
      pressProps = _usePress2.pressProps; // Needed to pick up the focusable context, enabling things like Tooltips for example


  var _useFocusable = useFocusable({}, ref),
      focusableProps = _useFocusable.focusableProps;

  var ariaSort = null;

  if (node.props.allowsSorting) {
    var _state$sortDescriptor;

    ariaSort = ((_state$sortDescriptor = state.sortDescriptor) == null ? void 0 : _state$sortDescriptor.column) === node.key ? state.sortDescriptor.direction : 'none';
  }

  return {
    columnHeaderProps: _babelRuntimeHelpersEsmExtends({}, mergeProps(gridCellProps, pressProps, focusableProps), {
      role: 'columnheader',
      id: $fd8271485d8e52f870169aca977a9c1$export$getColumnHeaderId(state, node.key),
      'aria-colspan': colspan && colspan > 1 ? colspan : null,
      'aria-sort': ariaSort
    })
  };
}
export function useTableRowGroup() {
  return {
    rowGroupProps: {
      role: 'rowgroup'
    }
  };
}
export function useTableRow(props, state) {
  var node = props.node,
      ref = props.ref,
      isVirtualized = props.isVirtualized,
      isSelected = props.isSelected,
      isDisabled = props.isDisabled;

  var _useSelectableItem2 = useSelectableItem({
    selectionManager: state.selectionManager,
    key: node.key,
    ref: ref,
    isVirtualized: isVirtualized
  }),
      itemProps = _useSelectableItem2.itemProps;

  var _usePress3 = usePress(_babelRuntimeHelpersEsmExtends({}, itemProps, {
    isDisabled: isDisabled
  })),
      pressProps = _usePress3.pressProps;

  var rowProps = _babelRuntimeHelpersEsmExtends({
    role: 'row',
    'aria-selected': isSelected,
    'aria-labelledby': $fd8271485d8e52f870169aca977a9c1$export$getRowLabelledBy(state, node.key)
  }, pressProps);

  if (isVirtualized) {
    rowProps['aria-rowindex'] = node.index + state.collection.headerRows.length + 1; // aria-rowindex is 1 based
  }

  return {
    rowProps: rowProps
  };
}
export function useTableRowHeader(props, state) {
  var _useTableCell2 = useTableCell(props, state),
      gridCellProps = _useTableCell2.gridCellProps;

  var columnKey = props.node.column.key;
  return {
    rowHeaderProps: _babelRuntimeHelpersEsmExtends({}, gridCellProps, {
      role: 'rowheader',
      id: $fd8271485d8e52f870169aca977a9c1$export$getCellId(state, props.node.parentKey, columnKey)
    })
  };
}
export function useTableSelectionCheckbox(props, state) {
  var key = props.key,
      isDisabled = props.isDisabled;
  var manager = state.selectionManager;
  var checkboxId = useId();
  var isSelected = state.selectionManager.isSelected(key) && !isDisabled;

  var onChange = function onChange() {
    return manager.select(key);
  };

  return {
    checkboxProps: {
      id: checkboxId,
      'aria-label': 'Select',
      'aria-labelledby': checkboxId + " " + $fd8271485d8e52f870169aca977a9c1$export$getRowLabelledBy(state, key),
      isSelected: isSelected,
      onChange: onChange
    }
  };
}
export function useTableSelectAllCheckbox(state) {
  var _state$selectionManag = state.selectionManager,
      isEmpty = _state$selectionManag.isEmpty,
      isSelectAll = _state$selectionManag.isSelectAll;
  return {
    checkboxProps: {
      'aria-label': 'Select All',
      isSelected: isSelectAll,
      isIndeterminate: !isEmpty && !isSelectAll,
      onChange: function onChange() {
        return state.selectionManager.toggleSelectAll();
      }
    }
  };
}